import * as CONSTRUCTOR from '../../generate';
import * as Fragments from './fragments';

export const CREATE_SHARED_MEDIA = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'createSharedMedia',
    operationName: 'createSharedMedia',
    args: [
      { name: 'parent_type', type: 'String', required: true },
      { name: 'parent_id', type: 'String', required: true },
      { name: 'file_name', type: 'String', required: true },
      { name: 'file_content', type: 'String', required: true },
      { name: 'file_type', type: 'String' },
    ],
    argsMap: [
      { name: 'parent_type', value: 'parent_type' },
      { name: 'parent_id', value: 'parent_id' },
      { name: 'file_name', value: 'file_name' },
      { name: 'file_content', value: 'file_content' },
      { name: 'file_type', value: 'file_type' },
    ],
    fields: '{...SharedMediaResponseFields}',
    fragments: [Fragments.sharedMediaResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const CREATE_SHARED_MEDIA_FROM_S3 = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'createSharedMediaFromS3',
    operationName: 'createSharedMediaFromS3',
    args: [
      { name: 'parent_type', type: 'String', required: true },
      { name: 'parent_id', type: 'String', required: true },
      { name: 'source_bucket', type: 'String', required: true },
      { name: 'source_key', type: 'String', required: true },
      { name: 'file_name', type: 'String', required: true },
      { name: 'file_type', type: 'String' },
      { name: 'uploader_user_aws_id', type: 'String' },
    ],
    argsMap: [
      { name: 'parent_type', value: 'parent_type' },
      { name: 'parent_id', value: 'parent_id' },
      { name: 'source_bucket', value: 'source_bucket' },
      { name: 'source_key', value: 'source_key' },
      { name: 'file_name', value: 'file_name' },
      { name: 'file_type', value: 'file_type' },
      { name: 'uploader_user_aws_id', value: 'uploader_user_aws_id' },
    ],
    fields: '{...SharedMediaResponseFields}',
    fragments: [Fragments.sharedMediaResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const CREATE_SHARED_MEDIA_PRESIGNED_UPLOAD = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'createSharedMediaPresignedUpload',
    operationName: 'createSharedMediaPresignedUpload',
    args: [
      { name: 'parent_type', type: 'String', required: true },
      { name: 'parent_id', type: 'String', required: true },
      { name: 'file_name', type: 'String', required: true },
      { name: 'file_content_type', type: 'String', required: true },
      { name: 'file_size_bytes', type: 'Int', required: true },
      { name: 'file_type', type: 'String' },
      { name: 'source_app', type: 'String' },
    ],
    argsMap: [
      { name: 'parent_type', value: 'parent_type' },
      { name: 'parent_id', value: 'parent_id' },
      { name: 'file_name', value: 'file_name' },
      { name: 'file_content_type', value: 'file_content_type' },
      { name: 'file_size_bytes', value: 'file_size_bytes' },
      { name: 'file_type', value: 'file_type' },
      { name: 'source_app', value: 'source_app' },
    ],
    fields: '{...SharedMediaPresignedUploadResponseFields}',
    fragments: [Fragments.sharedMediaPresignedUploadResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const CONFIRM_SHARED_MEDIA_UPLOAD = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'confirmSharedMediaUpload',
    operationName: 'confirmSharedMediaUpload',
    args: [
      { name: 'shared_media_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'shared_media_id', value: 'shared_media_id' },
    ],
    fields: '{ status }',
    fragments: [],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const DELETE_SHARED_MEDIA = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'deleteSharedMedia',
    operationName: 'deleteSharedMedia',
    args: [
      { name: 'shared_media_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'shared_media_id', value: 'shared_media_id' },
    ],
    fields: '{ success message }',
    fragments: [],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};
